import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseDrawerButton } from '../CloseDrawerButton';
import { DrawerLogo } from '../Logo';
import { LogoText } from '../LogoText';
import scss from './DrawerTopRow.module.scss';
export const DrawerTopRow = ({ closeDrawer }) => (_jsxs("div", Object.assign({ className: scss.drawerTopRow }, { children: [_jsx(DrawerLogo, {}), _jsx(LogoText, {}), _jsx(CloseDrawerButton, { closeDrawer: closeDrawer })] })));
